import { Component, OnInit, ViewChild, TransferState, makeStateKey, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { MktContentService } from 'src/app/core/services/mkt-content.service';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { MktSEOService, MktTaggingTransformationService } from 'src/app/core/services';
import { getBrowserNameForTagging } from './utility/browser-util';
import { OfferUtilService } from 'src/app/common/services/offer-util.service';
import { FeatureFlagService } from './utility/feature-flag.service';
import { CitiShopPropsService } from './utility/citi-shop-props.service';
import { isPlatformServer } from '@angular/common';

const IS_BUNDLE_LOADED_KEY = makeStateKey<boolean>('isBundleLoaded');
const IS_PAGE_NOT_FOUND_KEY = makeStateKey<boolean>('isCitiShopPageNotFound');

@Component({
  selector: 'app-citi-shop',
  templateUrl: './citi-shop.component.html',
  styleUrls: ['./citi-shop.component.scss'],
  standalone: false
})
export class CitiShopComponent implements OnInit {
  public content: any;
  public contentText: any;
  public videoSectionContent: any;
  public pageNotFound: boolean;
  public bundleLoaded: boolean;
  public addToButton: string;
  downloadButton: boolean;
  hideButton: boolean;
  userIsEnrolled: boolean = false;
  showSuspendModal = false;
  loginStatus: string;
  mobileInstructions = false;
  displaySafariInstructions = false;
  routeUrl;
  private routeSub: Subscription = new Subscription();
  @ViewChild('faqComponent') public faqComponent;
  suspendDialogParams;
  disableDownloadCTAButton = false;
  MOBILE_INS_PAGE_TYPE = ['ioschrome','iosedge','androidchrome','androidedge'];

  constructor(
    private _mktContentStorageService: MktContentStorageService,
    private _mktContentService: MktContentService,
    private route: ActivatedRoute,
    private state: TransferState,
    private _mktTaggingTransformationService: MktTaggingTransformationService,
    private mktSEOService: MktSEOService,
    private _offerUtilService: OfferUtilService,
    private titleService: Title,
    private _featureFlagService: FeatureFlagService,
    public csp: CitiShopPropsService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: string,

  ) {
    this._mktContentService.microsite.next(false);
    this.bundleLoaded = this.state.get(IS_BUNDLE_LOADED_KEY, false);
  }

  ngOnInit(): void {
    this.pageNotFound = false;
    this.routeUrl = this.route.snapshot.params;
    this.loginStatus = (this.route.snapshot.queryParams['wfextenrolled'] || 'false');
    if(this.loginStatus === 'true') {
      this.userIsEnrolled = true;
    }else{
      this.showSuspendModal = true;
    }
    this.setMobileInsPage();
    this.loadContent();
  }

  private browserOnInit() {
    if(isPlatformServer(this.platformId)) return;
    if (!this.csp.isBrowser()) return;
    this.loadTagging();
  }

  private async loadContent() {
    this.state.get(IS_BUNDLE_LOADED_KEY, true);
    this.commonOnInit();
  }

  private commonOnInit() {
    this.content = this._mktContentStorageService.get('Digital_Wallet', 'copy', 'Citi-Shop');
    const configContent = this._mktContentStorageService.get('Digital_Wallet', 'copy', 'CitishopConfig');
    if (this.content?.TEXT) {
      this.content = this._featureFlagService.loadFeatureFlag(this.content, configContent);
      this.csp.extractContent(this.content);
      this.contentText = this.content?.TEXT;
      	// Disable citishop
        this.disablePage();
        if(this.pageNotFound) return;
      if(this.content?.suspendDialogParams){
        this.suspendDialogParams = this.content.suspendDialogParams;
      }

      this.titleService.setTitle(this.contentText.title);
      const seoTags = this.content?.seoTags || '{}';
      if (seoTags) {
        this.mktSEOService.setContentfulSeoTags(seoTags);
      }
      if(this.content?.videoSection){
        this.videoSectionContent = this.content.videoSection;
      }
      this.bundleLoaded = true;
    } else {
      this.router.navigateByUrl('page-not-found');
      this.state.set(IS_PAGE_NOT_FOUND_KEY, true);
    }
    this.browserOnInit();
  }

  private setMobileInsPage() {
    if(this.routeUrl.pageType === 'home' || this.loginStatus === 'true'){
      return;
    }
    else if(this.routeUrl.pageType === 'iossafari'){ // Display iosSafari page
      this.displaySafariInstructions = true;
    }
    else if(this.MOBILE_INS_PAGE_TYPE.includes(this.routeUrl.pageType)){ // Display page except iosSafari
      this.mobileInstructions = true;
    }
    else{
      this.router.navigateByUrl('page-not-found');
    }
  }

  private disablePage() {
    const mobileInsStatus = this.contentText?.mobileInstructionsActive;
    if(this.routeUrl.pageType === 'home' && !this.contentText.active){
      this.router.navigateByUrl('page-not-found');
    }
    else if(this.routeUrl.pageType === 'iossafari' && !mobileInsStatus?.iossafari){
      this.displaySafariInstructions = false;
      this.router.navigateByUrl('page-not-found');
    }
    else if(this.MOBILE_INS_PAGE_TYPE.includes(this.routeUrl.pageType) && !mobileInsStatus?.[this.routeUrl.pageType]){
      this.mobileInstructions = false;
      this.router.navigateByUrl('page-not-found');
    }
  }

  ctabuttonClicked(event){
    // commected to test safari page redirect.
    // if(this.browserName.toLowerCase() === 'safari') {
    //   this.displaySafariInstructions = true;
    //  } else {
    //    this.displaySafariInstructions = false;
    //  }
  }

  private loadTagging(){
    const taggingIds = {
      'iossafari': '641_c_CitiShop_PreLogin_Instructions_iossafari',
      'ioschrome': '641_b_CitiShop_PreLogin_Instructions_ioschrome',
      'iosedge': '641_d_CitiShop_PreLogin_Instructions_iosedge',
      'androidchrome': '641_e_CitiShop_PreLogin_Instructions_androidchrome',
      'androidedge': '641_f_CitiShop_PreLogin_Instructions_androidedge'
    };
    if(this.routeUrl.pageType === 'home'){
      let userStatus = this.userIsEnrolled ? 'Enrolled' : 'Not Enrolled';
      this._mktTaggingTransformationService.tagMktCompareCards('citishop_landing', { 'form_type': getBrowserNameForTagging(this.userIsEnrolled), 'enrollment_status' : userStatus });
    }
    else{
      this._mktTaggingTransformationService.triggerPageTagging('nonicms_content', taggingIds[this.routeUrl.pageType]);
    }
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }
}

